import { Component } from '@angular/core';
import { AbstractInputComponent } from '@shared/form-elements/input/abstract-input/abstract-input.component';
import { TranslateSafePipe } from '@shared/translate-safe/translate-safe.pipe';
import { InputComponent } from '../input/input.component';

@Component({
    selector: 'app-input-email',
    templateUrl: './input-email.component.html',
    imports: [InputComponent, TranslateSafePipe]
})
export class InputEmailComponent extends AbstractInputComponent {}
